export default __webpack_public_path__ + "static/media/it.bba84d45.svg";